//import App from "./components/App";

import MarketingMaterials from "./components/MarketingMaterials";

// React y ReactDOM estan disponibles directamente

const {render} = wp.element;


// const element = wp.element.createElement('h1', {}, 'My content');
const container = document.getElementById('baum-marketing-materials');

if (container) {
    render(<MarketingMaterials/>, container);
}
